import './Page.css';
import './Dashbaord.css'
import AdvertisingHead from '../Components/DashboardComponents/AdvertisingHead/AdvertisingHead';
import OrderDetails from '../Components/DashboardComponents/OrdersDetails/OrderDetails';
import RavenueChart from '../Components/DashboardComponents/RavenueChart/RavenueChart';
import RecentOrders from '../Components/DashboardComponents/RecentOrders/RecentOrders';
import UserInfo from '../Components/DashboardComponents/UserInfo/UserInfo';
import SalesPerformance from '../Components/DashboardComponents/SalesPerformance/SalesPerformance';
import TopCategories from '../Components/DashboardComponents/TopCategories/TopCategories';
import Tempreture from '../Components/DashboardComponents/Tempreture/Tempreture';
import WebStats from '../Components/DashboardComponents/WebStats/webStats';
import { useDashboardData } from '../Context/DashboardContext/dashboardContext';

const Dashboard = () => {
  const {performanceInsights,loading2,topProducts,topCategories} = useDashboardData();

  return (
    <div className="HomePage">
      <div className='dashboard-main-page'>
        <div className='left-side-widgets'>
          <AdvertisingHead />
          <OrderDetails />
          <RavenueChart />
          <RecentOrders heading={'Recent Order'} />
          <WebStats/>
        </div>
        <div className='right-side-widgets'>
          <UserInfo />
          <div className='dashboard-sale-performance-and-firewall'>
            <SalesPerformance performanceInsights={loading2 ? 0 : performanceInsights?.averageScore} />
            <Tempreture />
          </div>
          <TopCategories data={topCategories} heading={'Top Categories'} is_category={true} />
          <TopCategories data={topProducts} heading={'Top Products'} is_category={false} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;